module.exports = __webpack_public_path__ + "static/IMG_3410-e2a3990a29e28b21b1e9947a53baf7fe.gif";